import * as _ from "lodash";
import { combineReducers } from "redux";
import undoable, { includeAction } from "redux-undo";

import { types } from "@/actions/map";

import global from "./global";
import mode from "./mode";

// Each history entry holds a full copy of the lights collection, so an unbounded
// past/future grows until the tab is killed on memory-constrained devices.
const historyLimit = 25;

/**
 * Builds the undo/redo configuration for a given value store (global or mode).
 *
 * @param configurationType - The value store type ("global" or "mode").
 * @returns The undo/redo configuration object.
 */
export const undoableConfiguration = (configurationType) => {
    const configurationActionTypes = types.VALUES[_.toUpper(configurationType)];
    const initTypes = [];

    const includedActions = [
        configurationActionTypes.UPDATE_LIGHTS,
        configurationActionTypes.SET_LIGHTS,
        configurationActionTypes.DELETE_LIGHTS,
        configurationActionTypes.ADD_GROUP_GEOMETRY,
        configurationActionTypes.DELETE_GROUP_GEOMETRY,
        configurationActionTypes.UPDATE_MARKERS,
        configurationActionTypes.DELETE_MARKERS,
    ];

    if (configurationType !== "global") {
        initTypes.push(types.GENERAL.CHANGE_MODE);
        includedActions.push(configurationActionTypes.SELECT_LIGHTS);
        includedActions.push(configurationActionTypes.ADD_TEMPORARY_LIGHT);
        includedActions.push(configurationActionTypes.ADD_TEMPORARY_MARKER);
    }

    return {
        filter: includeAction(includedActions),
        limit: historyLimit,
        undoType: configurationActionTypes.UNDO,
        redoType: configurationActionTypes.REDO,
        clearHistoryType: configurationActionTypes.SET_INIT_HISTORY,
        initTypes,
    };
};

export default combineReducers({
    global: undoable(global, undoableConfiguration("global")),
    mode: undoable(mode, undoableConfiguration("mode")),
});
